import NewTemplateTable from "../../../../../pages/app/admin/library/templates/NewTemplateTable";
import ElevatedPaper, { DEFAULT_STYLE } from "../../../../ElevatedPaper";

const ProviderTemplateTable = () => {
  return (
    <ElevatedPaper sx={{ ...DEFAULT_STYLE, minHeight: "calc(100vh - 4.4rem)" }}>
      <NewTemplateTable />
    </ElevatedPaper>
  );
};

export default ProviderTemplateTable;
